import { render, staticRenderFns } from "./depttsmadiolg.vue?vue&type=template&id=4a8dd095&scoped=true"
import script from "./depttsmadiolg.vue?vue&type=script&lang=js"
export * from "./depttsmadiolg.vue?vue&type=script&lang=js"
import style0 from "./depttsmadiolg.vue?vue&type=style&index=0&id=4a8dd095&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8dd095",
  null
  
)

export default component.exports